package fr.frux.core.database

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import fr.frux.core.database.coredatabase.newInstance
import fr.frux.core.database.coredatabase.schema
import kotlin.Unit

public interface FruxDatabase : Transacter {
  public val clusterPyramidCacheQueries: ClusterPyramidCacheQueries

  public val favoriteQueries: FavoriteQueries

  public val siteQueries: SiteQueries

  public val speciesCacheQueries: SpeciesCacheQueries

  public val treeQueries: TreeQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = FruxDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): FruxDatabase = FruxDatabase::class.newInstance(driver)
  }
}
